import { render, staticRenderFns } from "./CharacterDetail.vue?vue&type=template&id=f302a296&scoped=true&"
import script from "./CharacterDetail.vue?vue&type=script&lang=js&"
export * from "./CharacterDetail.vue?vue&type=script&lang=js&"
import style0 from "./CharacterDetail.vue?vue&type=style&index=0&id=f302a296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f302a296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f302a296')) {
      api.createRecord('f302a296', component.options)
    } else {
      api.reload('f302a296', component.options)
    }
    module.hot.accept("./CharacterDetail.vue?vue&type=template&id=f302a296&scoped=true&", function () {
      api.rerender('f302a296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/advocacy/CharacterDetail.vue"
export default component.exports